import React, { Component } from 'react';
import { Link, utils } from '@ltfe/ltfe-core-lib';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import { View, StyleSheet } from 'react-native';
import {
    JDText,
    JDPopupWindow,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib';
const { pt } = utils;
const successInfo = {
    title: '未开场自动退款',
    icon: 'https://img10.360buyimg.com/img/jfs/t1/285218/5/3889/1064/67d7ec4aF1e61d33f/552eca02af7f753e.png',
    tips: '若拼场失败或者影城取消放映，将于7个工作日内自动退款'
};
const errorInfo = {
    title: '不支持自助退票改签',
    icon: 'https://img30.360buyimg.com/img/jfs/t1/284163/16/4062/1049/67d7f403F22992eb6/e4cccdbbacf80cfb.png',
    tips: '因预约放映特殊性，成功参与拼场后暂不支持自助退票改签'
};
class GroupBuyingRule extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <View style={ st.group_buying_rule }>
                <View style={ st.group_buying_rule_row }>
                    <View style={ st.group_buying_rule_row_top }>
                        <JDImage
                            source={ {
                                uri: successInfo.icon
                            } }
                            style={ st.group_buying_rule_row_top_icon }
                        />
                        <JDText style={ st.group_buying_rule_row_top_text }>
                            {successInfo.title}
                        </JDText>
                    </View>
                    <View style={ st.group_buying_rule_row_bottom }>
                        <JDText style={ st.group_buying_rule_row_bottom_text }>
                            {successInfo.tips}
                        </JDText>
                    </View>
                </View>
                <View style={ st.group_buying_rule_line } />
                <View style={ st.group_buying_rule_row }>
                    <View style={ st.group_buying_rule_row_top }>
                        <JDImage
                            source={ {
                                uri: errorInfo.icon
                            } }
                            style={ st.group_buying_rule_row_top_icon }
                        />
                        <JDText style={ st.group_buying_rule_row_top_text }>
                            {errorInfo.title}
                        </JDText>
                    </View>
                    <View style={ st.group_buying_rule_row_bottom }>
                        <JDText style={ st.group_buying_rule_row_bottom_text }>
                            {errorInfo.tips}
                        </JDText>
                    </View>
                </View>
            </View>
        );
    }
  hide = () => {
      this.props && this.props.onHide();
  };
}
const st = StyleSheet.create({
    group_buying_rule: {
        padding: pt(10),
        backgroundColor: '#fff',
        marginBottom: pt(5)
    },
    group_buying_rule_row: {},
    group_buying_rule_row_top: {
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    group_buying_rule_row_top_icon: {
        width: pt(16),
        height: pt(16),
        marginRight: pt(8),
        alignItems: 'center'
    },
    group_buying_rule_row_top_text: {
        color: '#000000',
        fontSize: pt(12),
        lineHeight: pt(16),
        fontFamily: 'PingFangSC-Medium',
        wordWrap: 'break-word'
    },
    group_buying_rule_row_bottom: {
        marginTop: pt(4),
        paddingLeft: pt(24),
        flexDirection: 'row',
        alignItems: 'center'
    },
    group_buying_rule_row_bottom_text: {
        color: '#666666',
        fontSize: pt(12),
        lineHeight: pt(16),
        fontFamily: 'PingFangSC-Regular'
    },
    group_buying_rule_line: {
        height: pt(1),
        width: '100%',
        backgroundColor: '#0000000D',
        marginTop: pt(16),
        marginBottom: pt(16)
    }
});
export default GroupBuyingRule;